import { withRouter, Redirect } from "react-router-dom"
import React from "react"
import L10n from "lib/carrot-l10n/index"
import PropTypes from "prop-types"
import ProvidersByCountry from "content/Providers.json"
import ProviderFinderLayout, { Breadcrumbs } from "components/views/providerfinder/ProviderFinderLayout"
import { HR } from "../atoms/Atoms"
import { Spacer } from "../atoms/Atoms"
import { SinglePathSVG } from "../SVG"
import { BodySmall } from "../atoms/Bodies"
import { TextLink } from "../atoms/links/TextLink"
import { Button } from "../atoms/buttons/Button"
import { ProviderFinderSideBar } from "components/views/providerfinder/SideBar"
import { getIsUsa } from "reducers/userInfo"
import { useSelector } from "react-redux"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const DirectionsLink = ({ address }) => {
  const getGoogleDirections = (address) => {
    const googleBaseUrl = "https://www.google.com/maps/dir//"
    const encodedAddress = encodeURIComponent(address)
    return googleBaseUrl + encodedAddress
  }
  return (
    <TextLink to={getGoogleDirections(address)} target="_blank">
      Directions
    </TextLink>
  )
}

const ProviderHeader = ({ carrotPartner, name }) => {
  const bookAnAppointmentInstructions = carrotPartner ? (
    <>
      <Spacer height={0} expand />
      <div className="flex justify-end" style={{ minWidth: "128px" }}>
        <Button
          to={`/talk-to-carrot/sendmessage/bookappointment/provider/${encodeURIComponent(name)}`}
          horizontalPadding={35}
        >
          <div className="dib v-tbtm">
            <SinglePathSVG icon="providerCalendar" additionalClasses="carrot-orange" />
          </div>
          <div className="dib pl2">Book</div>
        </Button>
      </div>
    </>
  ) : null
  return (
    <>
      <div className={"flex flex-row"}>
        <H2 variant="dark">{name}</H2>
        {bookAnAppointmentInstructions}
      </div>
    </>
  )
}

const ProviderSize = ({ size }) => (
  <p
    className="ttu lh-copy gotham-text"
    style={{
      letterSpacing: "0.07rem",
      fontSize: "0.6875rem"
    }}
  >
    <span className="fw5">{l`providerSize`}:</span>
    <span className="black-60">&nbsp;{size}</span>
  </p>
)

const CarrotPartnerGem = () => (
  <span className="v-mid mr2 dib">
    <SinglePathSVG icon="carrotPartner" additionalClasses="carrot-orange" />
  </span>
)

const Provider = ({ address, carrotPartner, name, size, phone, website }) => (
  <div className="flex flex-row mb4">
    <div className={"min-w15 mv1"}>{carrotPartner && <CarrotPartnerGem />}</div>
    <div className={"flex-auto"}>
      <ProviderHeader carrotPartner={carrotPartner} name={name} />
      {size && <ProviderSize size={size} />}
      <div className="mt2">
        <BodySmall>{address}</BodySmall>
      </div>
      <div className="flex flex-row">
        {phone && (
          <p className="mr3">
            <TextLink to={`tel:${phone}`}>{phone}</TextLink>
          </p>
        )}
        <p className="mr3">
          <TextLink to={website} target="_blank">{l`visitWebsite`}</TextLink>
        </p>
        <p>
          <DirectionsLink address={address} />
        </p>
      </div>
    </div>
  </div>
)

const Main = ({ providers, country, subRegion, city }) => {
  const isUsa = useSelector(getIsUsa)
  const providerArray = []
  const breadcrumbsList = [
    { text: country, to: "/providerfinder" },
    { text: subRegion, to: `/providerfinder/${country}/${subRegion}` },
    { text: city }
  ]

  const providerEntries = Object.entries(providers)
  const listContainsCarrotPartners = providerEntries.some(([_, provider]) => provider.carrotPartner)
  Object.entries(providers).forEach(([providerName, provider], index) => {
    providerArray.push(
      <div key={index} className="mt35 mb3">
        <HR color={"black-20"} />
      </div>
    )
    providerArray.push(<Provider key={providerName} name={providerName} {...provider} />)
  })

  return (
    <>
      <div>
        <Breadcrumbs list={breadcrumbsList} />
      </div>
      {listContainsCarrotPartners && (
        <div className="mt3">
          <BodySmall color="black-50">
            <CarrotPartnerGem />
            {isUsa
              ? "Carrot Partners offer exclusive benefits like priority booking and lower negotiated rates."
              : "Carrot Partners offer exclusive benefits like lower negotiated rates."}
          </BodySmall>
        </div>
      )}
      <div>{providerArray}</div>
    </>
  )
}

const City = (props) => {
  const { country, subRegion, city } = props.match.params
  let providers
  try {
    providers = ProvidersByCountry[country][subRegion][city]
  } catch (caughtError) {
    return <Redirect to="/providerfinder" />
  }
  if (providers === undefined) {
    return <Redirect to="/providerfinder" />
  }

  return (
    <ProviderFinderLayout
      headerText={l`providerFinder`}
      main={<Main providers={providers} country={country} subRegion={subRegion} city={city} />}
      sideBar={<ProviderFinderSideBar />}
    />
  )
}

City.propTypes = {
  history: PropTypes.object.isRequired
}

export default withRouter(City)
